<template>
  <v-app>
    <v-navigation-drawer v-model="controls.drawer" width="322px" floating app>
      <v-layout
        align-center
        justify-center
        column
        class="app-logo-container"
        style="height: 322px"
      >
        <div class="app-logo-sheet">
          <v-img
            :src="require('@/assets/images/eonlife_logo_1.png')"
            width="100px"
            class="ma-6"
          ></v-img>
        </div>
        <div class="app-company--name mt-8">EONLife</div>
        <div class="app-project--name mt-2">Admin CMS</div>
      </v-layout>

      <v-list class="app-nav" flat>
        <v-subheader class="mb-5">
          <div class="app-nav--title mx-auto">NAVIGATION</div>
        </v-subheader>
        <template v-for="item in navItems">
          <v-list-item
            v-if="!item.children"
            link
            :key="item.label"
            :to="item.to"
            class="font-weight-bold"
            active-class="white black--text"
          >
            <v-list-item-content>
              <v-list-item-title class="pa-2 app-nav--item">{{
                item.label
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-group v-else :key="item.label" :group="item.group">
            <template v-slot:activator>
              <v-list-item-title class="pa-2 app-nav--item font-weight-bold">
                {{ item.label }}
              </v-list-item-title>
            </template>
            <v-list-item
              class="pl-8"
              v-for="child in item.children"
              :key="child.label"
              link
              :to="child.to"
              active-class="white black--text"
            >
              <v-list-item-title class="pa-2 app-nav--item">
                {{ child.label }}
              </v-list-item-title>
            </v-list-item>
          </v-list-group>
        </template>
      </v-list>
      <template v-slot:append>
        <v-list>
          <v-menu top offset-y>
            <template v-slot:activator="{ on }">
              <v-list-item two-line v-on="on">
                <v-list-item-avatar>
                  <user-avatar size="40" :avatar="user.avatar" />
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>{{ user.full_name }}</v-list-item-title>
                  <v-list-item-subtitle>
                    {{ user.email ? user.email : user.phone_number }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </template>
            <v-list>
              <!-- <v-list-item
                :to="{ name: 'user.details', params: { id: user.id } }"
              >
                <v-list-item-title>Profile</v-list-item-title>
              </v-list-item>
              <v-list-item>
                <v-list-item-title>Settings</v-list-item-title>
              </v-list-item> -->
              <v-list-item @click="logoutConfirmDialog = true">
                <v-list-item-title>Log out</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-list>
      </template>
    </v-navigation-drawer>
    <v-content class="main-content">
      <div class="px-xl-12 px-lg-10 px-md-6 px-sm-4 px-xs-2">
        <slot />
      </div>
    </v-content>
    <ConfirmModal
      v-model="logoutConfirmDialog"
      title="Logout"
      message="Are you sure you want to logout?"
    >
      <v-btn text @click="logoutConfirmDialog = false">Cancel</v-btn>
      <v-btn color="primary" text @click="logout">Logout</v-btn>
    </ConfirmModal>
  </v-app>
</template>

<script>
import ControlsMixin from '@/utils/mixins/Controls'
import ConfirmModal from '@/components/modals/ConfirmModal'
import { mapState, mapActions, mapGetters } from 'vuex'
import UserAvatar from '@/components/UserAvatar'

export default {
  name: 'MainLayout',

  components: {
    UserAvatar,
    ConfirmModal
  },

  mixins: [ControlsMixin],

  data() {
    return {
      navItems: [
        // { label: 'Inbox', to: { name: 'inbox' } },
        { label: 'Users', to: { name: 'users' } },
        // { label: 'Content', to: { name: 'content' } },
        { label: 'Meals', to: { name: 'meals' } },
        { label: 'Meal Restrictions', to: { name: 'meal.restrictions' } },
        { label: 'Exercises', to: { name: 'exercises' } },
        { label: 'Plans', to: { name: 'plans' } },
        { label: 'Vouchers', to: { name: 'vouchers' } },
        {
          label: 'Questionnaires',
          group: 'questionnaires',
          children: [
            {
              label: 'Question List',
              to: { name: 'questionnaires.onboarding' }
            },
            {
              label: 'Reassessment Questions',
              to: { name: 'questionnaires.reassessment' }
            },
            {
              label: 'Categories',
              to: { name: 'questionnaires.categories' }
            }
          ]
        },
        { label: 'Modules', to: { name: 'modules' } },
        // { label: 'Notifications', to: { name: 'notification' } },
        {
          label: 'Notifications',
          group: 'notifications',
          children: [
            {
              label: 'Motivation',
              to: { name: 'notifications.motivation' }
            },
            {
              label: 'Diagnostic Reminder',
              to: { name: 'notifications.diagnostic-reminder' }
            },
            {
              label: 'Re-assessment',
              to: { name: 'notifications.reassessment' }
            }
          ]
        },
        { label: 'Postcodes', to: { name: 'postcodes' } },
        { label: 'Settings', to: { name: 'settings' } }
        // { label: 'Reports', to: { name: 'reports' } }
      ],
      logoutConfirmDialog: false
    }
  },

  computed: {
    ...mapState({
      user: state => state.auth.user
    }),
    ...mapGetters({
      avatarThumb: 'auth/avatarThumb'
    })
  },

  methods: {
    ...mapActions({
      logout: 'auth/logout'
    })
  }
}
</script>
